import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromThemes from '../reducers/themes.reducer';

export const getThemesState = createSelector(fromFeature.getThemeState, (state: fromFeature.ThemeState) => state.Themes);
export const getThemesEntities = createSelector(getThemesState, fromThemes.getThemesEntities);

export const getAllThemes = createSelector(getThemesEntities, entities => {
  return Object.keys(entities).map(id => entities[Number(id)]);
});

export const getThemesLoaded = createSelector(getThemesState, fromThemes.getThemesLoaded);
export const getThemesLoading = createSelector(getThemesState, fromThemes.getThemesLoading);
